module.exports = __webpack_public_path__ + "static/media/chefs-qualified.47f735c0.jpg";